import React from 'react';
import { RenderAppropriate } from '../../internals/RenderAppropriate';

import { HeadingFiveStyle } from '../../styles/typography/heading.styles';

interface FiveProps {
    children?: React.ReactNode;
    component?: React.ElementType;
    [key: string]: any;
}

interface FiveComponent extends React.FC<FiveProps> {
    Style?: typeof HeadingFiveStyle;
}
export const Five: FiveComponent = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(HeadingFiveStyle, rest, children, Component);

Five.Style = HeadingFiveStyle;
